module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki10_pc-85f57f9d0520c92cb24f3c93e8fbab92.jpg";